import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/regimen-test-concept";

export const pagingRegimenTestConcepts = (searchObject) => {
  var url = API_PATH + "/pagingRegimenTestConcepts";
  return axios.post(url, searchObject);
};

export const getRegimenTestConcept = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRegimenTestConcept = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRegimenTestConcept = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRegimenTestConcept = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const getRequestType = (obj) => {
  const values = [1, 2, 3, 4, 5, 6, 7, 8, 10]; //lấy các bộ xét nghiệm trừ 9 (xn lao tiềm ẩn)
  let url = API_PATH + `/get-request-type`;
  return axios.post(url, {...obj, values});
};

export const getRequestTypeDetail = (dictionarySystemId) => {
  let url = API_PATH + `/get-request-type-detail/${dictionarySystemId}`;
  return axios.get(url);
};